import type { IRecordTypeDefinition, IRecordTypeOverride } from '@platform/core/types';
import { formModelOf } from '@platform/features/modules/settings/form/formSummary';
import { hasForms, scopeFormOf } from '@platform/features/modules/settings/form/scopeForm';
import type { IFormListRow } from './IFormListRow';
import type { IRecordTypeFlags } from './IRecordTypeFlags';

/**
 * Пігулка «Розміщення» рядка «Налаштування › Форми» у просторі — те саме правило, що в пігулці сторінки модуля й рядку редактора форми
 * (прототип v4 laySrc — одне джерело для всіх трьох; рішення 2 етапу 10): «Глобально» — простір успадковує глобальну форму (inheritsGlobalForm
 * каталогу: власних forms немає, глобальна є, ADR-027); з прочитаним патчем перевизначення — scopeFormOf: форма, яку записав не редактор
 * (засіяні картки парламенту), — «Робочий простір» і тоді, коли є глобальна форма; форма редактора — «Робочий простір», якщо відрізняється
 * від стандартного макета; без патча (тип без перевизначення чи патч ще вантажиться) — за злитим визначенням (formModelOf: форма редактора,
 * засіяний макет реєстрів і фінансів). `published` — опубліковане визначення типу (стандартний макет, ширини). Чиста функція.
 */
export function wsFormSource(rt: IRecordTypeDefinition, flags: IRecordTypeFlags, patch: IRecordTypeOverride | undefined,
  published: IRecordTypeDefinition | undefined): IFormListRow['source'] {
  if (flags.inheritsGlobalForm && !hasForms(patch)) return 'global';
  return patch ? scopeFormOf(rt, patch, published, { global: false }).source : formModelOf(rt, published).source;
}
